module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-BoldItalic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-BoldItalic-webfont.eot
// module id = 686
// module chunks = 0